const DOMAIN_GROUPING_MESSAGES = {
    addingPreselected: ( count, groupName ) => `You will be adding ${count} selected domains to ${groupName}.`,
    tooMany: 'To optimize performance within your interactive DMARC canvases, create domain groups with less than 25 domains.',
};

export default DOMAIN_GROUPING_MESSAGES;
